import React, { Component } from 'react';

import EmptyTubeStand from './img/empty-tube-stand.svg';

import { withTranslation } from 'react-i18next'

class Graphics extends Component {

  render () {
    return (
      <div id={'empty-tube-stand_'+this.props.id} className="empty-tube-stand">
        <img width="100" src={EmptyTubeStand} aria-label={this.props.t('Empty Tube Stand')} />
      </div>
    );
  }

}

export default withTranslation()(Graphics);
